import { format } from 'date-fns';
import { Timestamp } from 'firebase/firestore';

export function formatFirestoreDate(date: Date | Timestamp | null | undefined): string {
  if (!date) return 'N/A';
  
  try {
    const dateObj = date instanceof Timestamp ? date.toDate() : date;
    return format(dateObj, 'PPp');
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
}

export function ensureFirestoreDate(value: any): Date {
  if (!value) return new Date();
  if (value instanceof Date) return value;
  if (value instanceof Timestamp) return value.toDate();
  return new Date();
}

// Format date for display in Arabic (Gregorian format) using browser's Intl API
export function formatDateForArabic(date: Date): string {
  try {
    // Use Arabic locale with Gregorian calendar
    const arabicFormatter = new Intl.DateTimeFormat('ar-SA', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    
    return arabicFormatter.format(date);
  } catch (error) {
    console.warn('Failed to format Arabic date, falling back to default:', error);
    // Fallback to basic formatting if Arabic locale is not supported
    return new Intl.DateTimeFormat('ar', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  }
}